<mat-sidenav-container class="app-sidenav-container">
  <mat-sidenav
    #sidenav
    class="app-sidenav mat-elevation-z4"
    [opened]="!isScreenSmall"
    [mode]="isScreenSmall ? 'over' : 'side'"
    *ngIf="isOperator | async as isOperator"
  >
    <mat-toolbar>
      <a (click)="goToRoute('/dashboard')" class="navbar-brand mb-0 h1">
        <img class="logo" alt="logo" />
      </a>
    </mat-toolbar>
    <mat-nav-list>
      <mat-list-item
        accessControl
        [userRole]="authorizedRoles"
        [ngClass]="{ active: clickedItem === '/dashboard' }"
        (click)="goToRoute('/dashboard')"
        class="app-mat-list-item"
      >
        <span>Dashboard</span>
      </mat-list-item>

      <mat-expansion-panel
        class="mat-elevation-z0"
        accessControl
        [userRole]="authorizedRoles"
        [displayStyle]="displayStyle"
      >
        <mat-expansion-panel-header>
          <mat-panel-title
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span>Administration</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-nav-list>
          <mat-list-item
            (click)="goToRoute('/products')"
            class="app-mat-list-item"
            [ngClass]="{ active: clickedItem === '/products' }"
            accessControl
            [userRole]="authorizedRoles"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span>Products</span>
          </mat-list-item>

          <mat-list-item
            (click)="goToRoute('/fill-prices')"
            [ngClass]="{ active: clickedItem === '/fill-prices' }"
            class="app-mat-list-item"
          >
            <span>Fill Prices</span>
          </mat-list-item>

          <mat-list-item
            (click)="goToRoute('/fill-servers')"
            [ngClass]="{ active: clickedItem === '/fill-servers' }"
            class="app-mat-list-item"
            accessControl
            [userRole]="siteAdminOnly"
          >
            <span>Fill Servers</span>
          </mat-list-item>

          <mat-list-item
            (click)="goToRoute('/fill-dongles')"
            [ngClass]="{ active: clickedItem === '/fill-dongles' }"
            class="app-mat-list-item"
            accessControl
            [userRole]="siteAdminOnly"
          >
            <span>Fill Dongles</span>
          </mat-list-item>

          <mat-list-item
            (click)="goToRoute('/product-settings')"
            [ngClass]="{ active: clickedItem === '/product-settings' }"
            class="app-mat-list-item"
          >
            <span>Product Settings</span>
          </mat-list-item>

          <mat-list-item
            (click)="goToRoute('/software-versions')"
            [ngClass]="{ active: clickedItem === '/software-versions' }"
            class="app-mat-list-item"
            accessControl
            [userRole]="authorizedRolesLocations"
          >
            <span>Software Versions</span>
          </mat-list-item>
        </mat-nav-list>
      </mat-expansion-panel>

      <mat-expansion-panel
        class="mat-elevation-z0"
        accessControl
        [userRole]="authorizedRoles"
        [displayStyle]="displayStyle"
      >
        <mat-expansion-panel-header>
          <mat-panel-title><span>Operation</span></mat-panel-title>
        </mat-expansion-panel-header>
        <mat-nav-list>
          <mat-list-item
            (click)="goToRoute('/distributors')"
            [ngClass]="{ active: clickedItem === '/distributors' }"
            class="app-mat-list-item"
          >
            <span>&nbsp;Distributors</span>
          </mat-list-item>
          <mat-list-item
            (click)="goToRoute('/operators')"
            [ngClass]="{ active: clickedItem === '/operators' }"
            class="app-mat-list-item"
          >
            <span>&nbsp;Operators</span>
          </mat-list-item>
          <mat-list-item
            (click)="goToRoute('/terminals')"
            [ngClass]="{ active: clickedItem === '/terminals' }"
            class="app-mat-list-item"
          >
            <span>Terminals</span>
          </mat-list-item>

          <mat-expansion-panel class="mat-elevation-z0">
            <mat-expansion-panel-header
              ><mat-panel-title><span>Fills</span></mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item
                (click)="goToRoute('/call-in-fill')"
                [ngClass]="{ active: clickedItem === '/call-in-fill' }"
                class="app-mat-list-item"
              >
                <span>Call In Fill</span>
              </mat-list-item>
              <mat-list-item
                routerLink="#"
                class="app-mat-list-item"
                [ngClass]="{ active: clickedItem === '/fill-active-carts' }"
              >
                <span>Fill Active Carts</span>
              </mat-list-item>
              <mat-list-item
                (click)="goToRoute('/fugs')"
                [ngClass]="{ active: clickedItem === '/fugs' }"
                class="app-mat-list-item"
              >
                <span>Fugs</span>
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>
          <mat-list-item
            (click)="goToRoute('/locations')"
            [ngClass]="{ active: clickedItem === '/locations' }"
            class="app-mat-list-item"
            accessControl
            [userRole]="authorizedRolesLocations"
          >
            <span>Locations</span>
          </mat-list-item>
        </mat-nav-list>
      </mat-expansion-panel>

      <mat-expansion-panel
        class="mat-elevation-z0"
        accessControl
        [userRole]="authorizedRolesOnboarding"
        [displayStyle]="displayStyle"
      >
        <mat-expansion-panel-header
          ><mat-panel-title><span>Approvals</span></mat-panel-title>
        </mat-expansion-panel-header>
        <mat-nav-list>
          <mat-list-item
            (click)="goToRoute('/approvals/locations')"
            class="app-mat-list-item"
            [ngClass]="{ active: clickedItem === 'approvals/locations' }"
            accessControl
            [userRole]="authorizedRoles"
          >
            <span>Locations</span>
          </mat-list-item>
          <mat-list-item
            (click)="goToRoute('/approvals/terminals')"
            class="app-mat-list-item"
            accessControl
            [userRole]="authorizedRoles"
          >
            <span>Terminals</span>
          </mat-list-item>
          <mat-expansion-panel
            class="mat-elevation-z0"
            accessControl
            [userRole]="authorizedRolesOnboarding"
            [displayStyle]="displayStyle"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span>Operator</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item
                [ngClass]="{
                  active:
                    clickedItem === '/approvals/operators/application-requests',
                }"
                (click)="goToRoute('/approvals/operators/application-requests')"
                class="app-mat-list-item"
                accessControl
                [userRole]="authorizedRoles"
              >
                <span>Application Request</span>
              </mat-list-item>
              <mat-list-item
                [ngClass]="{
                  active:
                    clickedItem === '/approvals/operators/application-process',
                }"
                (click)="goToRoute('/approvals/operators/application-process')"
                class="app-mat-list-item"
                accessControl
                [userRole]="authorizedRolesOnboarding"
              >
                <span>Application Process</span>
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>
        </mat-nav-list>
      </mat-expansion-panel>

      <mat-list-item
        accessControl
        [userRole]="authorizedRolesCompliance"
        (click)="goToRoute('/pom-trak-violations')"
        class="app-mat-list-item"
        [ngClass]="{ active: clickedItem === '/pom-trak-violations' }"
      >
        <span>GPS Violations</span>
      </mat-list-item>

      <mat-list-item
        accessControl
        [userRole]="authorizedReleaseManagerRoles"
        (click)="goToRoute('/software-update-management')"
        class="app-mat-list-item"
        [ngClass]="{ active: clickedItem === '/software-update-management' }"
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span>Software Releases</span>
      </mat-list-item>

      <mat-list-item
        accessControl
        [userRole]="authorizedRoles"
        (click)="goToRoute('/fill-blocks')"
        class="app-mat-list-item"
        [ngClass]="{ active: clickedItem === '/fill-blocks' }"
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span>Fill Blocks</span>
      </mat-list-item>

      <mat-expansion-panel
        class="mat-elevation-z0"
        accessControl
        [userRole]="authorizedRoles"
        [displayStyle]="displayStyle"
      >
        <mat-expansion-panel-header>
          <mat-panel-title><span>Reports</span></mat-panel-title>
        </mat-expansion-panel-header>
        <mat-nav-list>
          <mat-list-item
            (click)="goToRoute('/reports/fills')"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            [ngClass]="{ active: clickedItem === '/reports/fills' }"
            class="app-mat-list-item"
          >
            <span>Fills</span>
          </mat-list-item>
          <mat-list-item
            (click)="goToRoute('/reports/bill-acceptor')"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            [ngClass]="{ active: clickedItem === '/reports/bill-acceptor' }"
            class="app-mat-list-item"
          >
            <span>Bill Acceptor Count</span>
          </mat-list-item>
          <mat-list-item
            (click)="goToRoute('/reports/cash-in-out')"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            [ngClass]="{ active: clickedItem === '/reports/cash-in-out' }"
            class="app-mat-list-item"
          >
            <span>Cash In Out</span>
          </mat-list-item>
          <!--<mat-list-item
            (click)="goToRoute('/reports/game-play-level')"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            [ngClass]="{ active: clickedItem === '/reports/game-play-level' }"
            class="app-mat-list-item"
          >
            <span>Game Play Level</span>
          </mat-list-item>-->
          <mat-list-item
            (click)="goToRoute('/reports/saved-reports')"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            [ngClass]="{ active: clickedItem === '/reports/saved-reports' }"
            class="app-mat-list-item"
          >
            <span>Saved Reports</span>
          </mat-list-item>
          <mat-list-item
            (click)="goToRoute('/reports/terminal-info')"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            [ngClass]="{ active: clickedItem === '/reports/terminal-info' }"
            class="app-mat-list-item"
          >
            <span> Terminal Info</span>
          </mat-list-item>
          <mat-list-item
            (click)="goToRoute('/reports/terminal-error')"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            [ngClass]="{ active: clickedItem === '/reports/terminal-error' }"
            class="app-mat-list-item"
          >
            <span>Terminal Error</span>
          </mat-list-item>
          <mat-list-item
            routerLink="#"
            [ngClass]="{
              active: clickedItem === '/reports/wyoming-regulatory',
            }"
            class="app-mat-list-item"
          >
            <span>Wyoming Regulatory</span>
          </mat-list-item>
        </mat-nav-list>
      </mat-expansion-panel>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content class="app-sidenav-content2">
    <app-toolbar (toggleSidenav)="sidenav.toggle()"></app-toolbar>
    <div class="wrapper">
      <div class="overlay" *ngIf="isLoading | async as isLoading">
        <app-spinner></app-spinner>
      </div>

      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
